const isMacOS = () => /Mac/.test(navigator.userAgent);

const deleteShortcut = isMacOS() ? 'Fn + Del' : 'Del';

const useOperatingSystem = () => {
  const metaKey = isMacOS() ? '⌘' : 'Ctrl';
  const optionKey = isMacOS() ? '⌥' : 'Alt';

  return { isMacOS, metaKey, optionKey, deleteShortcut };
};

export default useOperatingSystem;
